/*
 *
 * WidgetMultipleOptions actions
 *
 */

import {
  GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER,
  GET_LIST_MULTIPLE_CHOICE_QUESTIONS_SUCCESS,
  GET_LIST_MULTIPLE_CHOICE_QUESTIONS_FAILED,
} from "./constants"

export function getListMultipleChoiceQuestionsWatcher(payload) {
  return {
    type: GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER,
    payload,
  }
}

export function getListMultipleChoiceQuestionsSuccess(payload) {
  return {
    type: GET_LIST_MULTIPLE_CHOICE_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getListMultipleChoiceQuestionsFailed() {
  return { type: GET_LIST_MULTIPLE_CHOICE_QUESTIONS_FAILED }
}
